<template>
    <div
        v-for="(info, index) in computedBannersInfo"
        :key="index"
        :class="[$style.slot, appStore.isDebugMode && $style.debug, !info.placement && $style.not_found]"
        :style="{
            top: info.sizeAndPosition.top,
            width: info.sizeAndPosition.width,
            height: info.sizeAndPosition.height,
            left: info.sizeAndPosition.left,
            '--slot-num': index + 1,
        }"
    >
        <AdContainer
            v-if="info.placement"
            :class="$style.banner"
            :placement="info.placement"
            respectHeight
        />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import AdContainer from '@/components/AdContainer/AdContainer.vue'
import { normalizeAdvancedBannerPosition } from '@/modules/adv/advanced-banners'
import type { PageAdType } from '@/modules/adv/types'
import type { BannerPositionSizeRaw } from '@/modules/main-frame/ads/game-ad-handler.types'
import { useAppStore } from '@/store/app-store'

type Props = {
    banners: BannerPositionSizeRaw[]
    isFullscreen: boolean
}

const props = defineProps<Props>()

const appStore = useAppStore()

const bannersType = computed((): PageAdType[] => {
    // on mobile fullscreen we can show both slots, otherwise there is a left sidebar with two portal banners
    if (props.isFullscreen && appStore.platform !== 'desktop') {
        return ['universal_banner_1', 'universal_banner_2']
    }
    return ['universal_banner_1']
})

const computedBannersInfo = computed(() => {
    return props.banners.map(normalizeAdvancedBannerPosition).map((banner, index) => ({
        placement: bannersType.value[index],
        sizeAndPosition: banner,
    }))
})
</script>
<style module>
.slot {
    position: absolute;
}

.debug {
    outline: 2px solid hotpink;
    background: rgba(255, 105, 180, 0.15);
}

.debug.not_found {
    outline-color: rgb(38, 3, 21);
    background: rgba(142, 128, 135, 0.15);
}

.debug::before {
    content: counter(slot-num);
    counter-reset: slot-num var(--slot-num);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    background: hotpink;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    padding: 2px 6px;
    line-height: 1;
    pointer-events: none;
}
.debug.not_found::before {
    background: rgb(38, 3, 21);
}

.banner {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
